<ng-container *ngIf="patientvideos.length">
    <div class="ui-g-12">
        <div class="ui-g">
            <div class="ui-g-12">
                <h1 class="video-h1 text-center"><b>Videos from Board Certified Physicians</b></h1>
            </div>
            <div class="ui-g-12" *ngFor="let patientvideo of patientvideos">
                <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 text-center">
                        <img [src]="patientvideo.imgsrc" alt="" class="video-img" />
                    </div>
                    <div class="ui-g-12 ui-md-8">
                        <h3><b> {{patientvideo.name}} </b></h3>
                        <p>
                            {{patientvideo.description}}
                        </p>
                        <a [href]="patientvideo.link" target="_blank">
                            <button pButton type="button" class="video-section-button" label="Watch Videos"></button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
